//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"AssociateObject",0,"SelectNXObject",0],[0,"EnableDetection",1,0],[1,"FocalLength",0,"Expression",0],[1,"HorizontalAngle",0,"Expression",0],[0,"ImageLocation",1,0],[0,"ImageType",1,0],[0,"MaximumDetectionQuantity",1,0],[1,"MaximumRange",0,"Expression",0],[1,"MinimumRange",0,"Expression",0],[0,"Name",1,0],[0,"Orientation",1,"CoordinateSystem",0],[0,"ReferencePlane",1,"Plane",0],[0,"SaveImage",1,0],[1,"SensorHeight",0,"Expression",0],[1,"SensorWidth",0,"Expression",0],[1,"TimeInterval",0,"Expression",0],[0,"TriggerOption",1,0],[1,"VerticalAngle",0,"Expression",0]],[[[],"GetModeType",{R_:{modeType:''}},0,0],[["modeType"],"SetModeType",{},1,0],[[],"GetDefinitionType",{R_:{definitionType:''}},0,0],[["definitionType"],"SetDefinitionType",{},1,0]],[]];
SPLM.Mechatronics.VisionCameraBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.VisionCameraBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.VisionCameraBuilder.ModeTypes = Object.freeze({
    "General" : "General", "Moving" : "Moving"});

SPLM.Mechatronics.VisionCameraBuilder.DefinitionTypes = Object.freeze({
    "AnglesofView" : "AnglesofView", "SensorDimensions" : "SensorDimensions"});

SPLM.Mechatronics.VisionCameraBuilder.TriggerOptions = Object.freeze({
    "EventBased" : "EventBased", "TimeBased" : "TimeBased"});

SPLM.Mechatronics.VisionCameraBuilder.ImageTypes = Object.freeze({
    "Png" : "Png", "Jpg" : "Jpg", "Gif" : "Gif", "Tiff" : "Tiff", "Bmp" : "Bmp"});

export default SPLM;